module.exports = __webpack_public_path__ + "img/whistle.7fb39538.svg";